<template>
  <v-container fluid>
    <h1 class="d-sr-only">Unser Vorstand – SC Budokwai Garbsen e.V.</h1>
    <v-row>
      <v-col
        v-for="(vorstand, i) in vorstands"
        :key="i"
        cols="12"
        xs="12"
        sm="12"
        md="6"
        lg="4"
        xl="4"
      >
        <v-card>
          <div class="d-flex flex-no-wrap justify-space-between">
            <div>
              <v-card-title
                class="text-h5"
                v-text="vorstand.funktion"
              ></v-card-title>

              <v-card-subtitle v-text="vorstand.name"></v-card-subtitle>

              <v-card-actions>
                <v-btn
                  v-if="vorstand.a !== ''"
                  class="primary--text ml-2 mt-5"
                  outlined
                  rounded
                  small
                  @click="task(vorstand.a)"
                >
                  E-Mail
                </v-btn>
                <v-btn
                  v-if="vorstand.b !== ''"
                  class="primary--text ml-2 mt-5"
                  outlined
                  rounded
                  small
                  @click="task(vorstand.b)"
                >
                  Anrufen
                </v-btn>
              </v-card-actions>
            </div>

            <div class="avatar-box ma-3">
              <v-img
                :src="
                  vorstand.src ||
                  'https://previews.123rf.com/images/apoev/apoev1904/apoev190400006/124108707-person-graue-fotoplatzhalter-mann-silhouette-auf-wei%C3%9Fem-hintergrund.jpg'
                "
                :alt="`Foto von ${vorstand.name}`"
                class="avatar-img"
                :aspect-ratio="1"
                cover
              />
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Vorstand",
  data: () => ({
    vorstands: [
      {
        color: "primary",
        funktion: "1. Vorsitzender",
        name: "Leonard Birkenfeld",
        src: "/vorstand/leonard.png",
        a: "bWFpbHRvOmVyc3RlcnZvcnNpdHplbmRlckBzYy1idWRva3dhaS5kZQ==",
        b: "dGVsOjAxNTc3NzI3MjQzMA==",
      },
      {
        color: "primary",
        funktion: "2. Vorsitzender",
        name: "Falk Oberwetter",
        src: "",
        a: "bWFpbHRvOnp3ZWl0ZXJ2b3JzaXR6ZW5kZXJAc2MtYnVkb2t3YWkuZGU=",
        b: "",
      },
      {
        color: "primary",
        funktion: "Kassenwartin",
        name: "Christin Hirche",
        src: "/vorstand/christin.png",
        a: "bWFpbHRvOmthc3NlbndhcnRpbkBzYy1idWRva3dhaS5kZQ==",
        b: "",
      },
      {
        color: "primary",
        funktion: "Schriftführerin",
        name: "Wiebke Dageförde",
        src: "/vorstand/wiebke.png",
        a: "",
        b: "",
      },
      {
        color: "primary",
        funktion: "Gerätewart",
        name: "Tim Baake",
        src: "",
        a: "",
        b: "",
      },
      {
        color: "primary",
        funktion: "Jugendwart",
        name: "Arne Reckhaus",
        src: "/vorstand/arne.png",
        a: "bWFpbHRvOmp1Z2VuZHdhcnRAc2MtYnVkb2t3YWkuZGU=",
        b: "dGVsOjAxNTIyOTU2MTM5NA==",
      },
      {
        color: "primary",
        funktion: "Sportwart",
        name: "Emre Tahtali",
        src: "/vorstand/emre.png",
        a: "",
        b: "",
      },
      {
        color: "primary",
        funktion: "Pressewart",
        name: "Marc Reinelt",
        src: "https://previews.123rf.com/images/apoev/apoev1904/apoev190400006/124108707-person-graue-fotoplatzhalter-mann-silhouette-auf-wei%C3%9Fem-hintergrund.jpg",
        a: "",
        b: "",
      },
    ],
  }),
  methods: {
    task(b64) {
      if (!b64) return;
      try {
        const decoded = atob(b64);
        window.location.href = decoded;
      } catch (e) {
        console.error("Fehler beim Decodieren der Base64-Zeichenfolge:", e);
      }
    },
  },
};
</script>

<style scoped>
/* Quadratische Box mit hartem Crop */
.avatar-box {
  width: 120px; /* bei Bedarf auf 100/140 anpassen */
  height: 120px;
  border-radius: 16px; /* weiche Ecken; mit .tile <-> 0 setzen */
  overflow: hidden; /* überschüssige Ränder sauber abschneiden */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  background: #f6f6f6;
  display: flex;
}

/* v-img auf Box einpassen und zuschneiden */
.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* zentriert & zugeschnitten */
  object-position: center;
}
</style>
